








import Vue from 'vue'
import PrivacyTxt from '~/components/car/information/PrivacyTxt.vue'
import CBackToTop from '~/components/shared/configurable/CBackToTop.vue'
import CCard from '~/components/shared/configurable/card/CCard.vue'
export default Vue.extend({
  components: {
    CBackToTop,
    PrivacyTxt,
    CCard
  },
  head() {
    return {
      title: this.$t('privacy') as string
    }
  }
})
